import { PAGEBUILDER_GENERAL_REDIRECT_URL } from '../reducers/builder/configReducer/actions';
import { IRedirectItem } from '../utils/interfaces';

const updateRedirectUrl = (payload: IRedirectItem[]) => ({
  type: PAGEBUILDER_GENERAL_REDIRECT_URL,
  payload
});

export default updateRedirectUrl;
